export enum DocusignTemplatesTableFields {
  title = 'title',
  description = 'description',
  docusignTemplateId = 'docusignTemplateId',
  createdAt = 'createdAt',
  actions = 'actions',
}
